module.exports = __webpack_public_path__ + "img/prata.97790f33.jpg";